module.exports = __webpack_public_path__ + "media/customizations/bridgelandlife/logo-new-03ec0b480de1593ee21531f2e4a4a280.png";